import { Component } from "@angular/core";

@Component({
  selector: "icon-swipe-right",
  templateUrl: "./swipe_right.svg",
  standalone: true,
})
export class SwipeRightIconComponent {}
